import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService } from '@services/auth.service';

export const roleGuard = (allowedRoles: string[]): CanMatchFn => {
  return () => {
    const auth = inject(AuthService);
    const token = auth.getAccessToken();

    return !!token?.primaryRole && allowedRoles.includes(token.primaryRole);
  };
};
